import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <main className="bg-white min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0a1628] to-[#162447] py-16 pt-32">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-black text-white mb-3">Terms of Service</h1>
          <p className="text-gray-300 text-sm">Last updated: March 28, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">

          <section>
            <p className="text-base">
              These Terms of Service ("Terms") govern your use of the Leak Detectives Las Vegas website
              and any services provided by Leak Detectives Las Vegas ("Company," "we," "us," or "our").
              By accessing our website or engaging our services, you agree to be bound by these Terms.
              If you do not agree, please do not use our website or services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">1. Services Provided</h2>
            <p className="mb-3 text-sm">
              Leak Detectives Las Vegas provides professional residential and commercial plumbing and leak
              detection services in Las Vegas, NV and surrounding Clark County areas, including but not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li>Pool and spa leak detection</li>
              <li>Slab leak detection and repair</li>
              <li>Water leak detection and diagnosis</li>
              <li>Home repiping and mainline replacement</li>
              <li>Emergency plumbing services</li>
              <li>Water heater installation and repair</li>
              <li>Water filtration and softener systems</li>
              <li>Drain cleaning and sewer line repair</li>
              <li>Water damage restoration</li>
              <li>Garbage disposal repair</li>
            </ul>
            <p className="mt-3 text-sm">
              All work is performed by licensed and insured technicians in compliance with Nevada state
              licensing requirements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">2. Estimates and Pricing</h2>
            <p className="text-sm">
              Free estimates are provided for diagnostic and service inquiries. All estimates are non-binding
              until a written service agreement is signed by both parties. Final pricing may vary based on
              actual conditions found during the service visit. We practice flat-rate and transparent pricing
              — any changes in scope will be communicated to you before work begins. We are not responsible
              for costs arising from hidden conditions not visible during the initial estimate.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">3. Scheduling and Appointments</h2>
            <p className="text-sm">
              Appointments are subject to availability. We make every effort to honor scheduled times;
              however, emergency calls and unforeseen circumstances may cause delays. We will notify you
              as promptly as possible of any scheduling changes. Cancellations requested less than 2 hours
              before a scheduled appointment may be subject to a trip charge at our discretion.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">4. Payment Terms</h2>
            <p className="text-sm">
              Payment is due upon completion of services unless otherwise agreed in writing. We accept
              cash, check, and major credit cards. Financing options may be available through third-party
              lenders such as Hearth. Past-due balances may be subject to a late fee of 1.5% per month.
              We reserve the right to pursue legal remedies for unpaid balances.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">5. Warranties</h2>
            <p className="text-sm">
              Workmanship is warranted against defects for a period specified in your service agreement,
              typically 1 year from the date of service. Equipment and materials carry manufacturer
              warranties, which will be passed through to you where applicable. Warranties are void
              if work is tampered with or modified by parties other than Leak Detectives Las Vegas.
              Warranty claims must be submitted in writing within the warranty period.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">6. Limitation of Liability</h2>
            <p className="text-sm">
              To the maximum extent permitted by applicable Nevada law, Leak Detectives Las Vegas shall
              not be liable for any indirect, incidental, consequential, special, or punitive damages
              arising from the use of our website or services, even if we have been advised of the
              possibility of such damages. Our total liability to you for any claim shall not exceed
              the amount you paid us for the specific service giving rise to the claim.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">7. Property Access and Safety</h2>
            <p className="text-sm">
              By scheduling a service, you authorize our technicians to access the relevant areas of
              your property as necessary to complete the work. You are responsible for ensuring the
              work area is safe and accessible. We are not liable for pre-existing conditions or
              damage caused by circumstances beyond our control, including but not limited to
              pre-existing structural issues, faulty materials installed by others, or undisclosed
              hazardous conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">8. Website Use</h2>
            <p className="text-sm">
              The content on this website is provided for informational purposes only and does not
              constitute professional advice. You may not reproduce, distribute, or commercially
              exploit any content from this website without our express written permission. We
              reserve the right to modify or discontinue the website at any time without notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">9. Governing Law</h2>
            <p className="text-sm">
              These Terms are governed by and construed in accordance with the laws of the State of
              Nevada, without regard to its conflict of law provisions. Any disputes arising under
              these Terms shall be resolved in the state or federal courts located in Clark County,
              Nevada, and you consent to the personal jurisdiction of such courts.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">10. Changes to These Terms</h2>
            <p className="text-sm">
              We reserve the right to modify these Terms at any time. Updated Terms will be posted
              on this page with a revised effective date. Your continued use of our website or services
              after any changes constitutes your acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">11. Contact Us</h2>
            <p className="text-sm mb-2">If you have questions about these Terms, please contact us:</p>
            <div className="bg-gray-50 rounded-lg p-5 text-sm space-y-1">
              <p><strong>Leak Detectives Las Vegas</strong></p>
              <p>Las Vegas, NV &amp; Clark County</p>
              <p>Phone: <a href="tel:7252675482" className="text-cyan-600 hover:underline">(725) 267-5482</a></p>
            </div>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="text-cyan-600 hover:underline text-sm font-semibold flex items-center gap-1">
            <i className="ri-arrow-left-line"></i> Back to Home
          </Link>
          <Link to="/privacy-policy" className="text-cyan-600 hover:underline text-sm">
            View Privacy Policy &rarr;
          </Link>
        </div>
      </div>
    </main>
  );
}
